<div class="card">
  <div class="title">{{ title() }}</div>
  @if (subtitle().component) {
    <ng-container *ngComponentOutlet="subtitle().component; inputs: subtitle().inputs"> </ng-container>
  }
  @for (detail of details(); track $index; let first = $first) {
    @if (first) {
      <div class="spacing"></div>
    }
    <div class="detail">{{ detail }}</div>
  }

  @if (showFooter()) {
    <div class="spacing"></div>
    <div class="footer">
      <div class="bottom-left">{{ bottomLeft() }}</div>
      <div class="bottom-right">
        @if (bottomRight() || isLoadingBottomRight()) {
          @if (isLoadingBottomRight()) {
            <glxy-loading-spinner [inline]="true"></glxy-loading-spinner>
          } @else {
            {{ bottomRight() }}
          }
        }
      </div>
    </div>
  }
</div>
